export default "__VITE_ASSET__QC9eM2VC__"